import { useState } from 'react';
import { useAuthContext } from './useAuthContext';

const useSignup = () => {
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const { dispatch } = useAuthContext();

    const signup = async (name, email, password, language) => {
        setIsLoading(true);
        setError(null);

        const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';

        const response = await fetch(`${baseUrl}/api/users/signup`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ name, email, password, language }),
        });
        const json = await response.json();

        if (!response.ok) {
            setIsLoading(false);
            setError(json.error);
        } else {
            if (!json._id) {
                console.error('Signup response is missing `_id`:', json);
                setError('Signup failed: Missing user ID.');
                setIsLoading(false);
                return;
            }

            // Save the user to local storage
            localStorage.setItem('user', JSON.stringify(json));

            // Update the auth context
            dispatch({ type: 'LOGIN', payload: json });

            setIsLoading(false);
        }
    };

    return { signup, isLoading, error };
};

export default useSignup;